import React from 'react';
import { formatStatSummary } from '../../data/statistics';

export default function Thank() {
  const styles = {
    heading: {
      color: 'white',
      fontSize: '2.5em',
      marginBottom: '40px',
      textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
    },
    highlight: {
      color: '#4ecdc4',
      fontWeight: 'bold'
    },
    nextSteps: {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      padding: '30px',
      borderRadius: '15px',
      margin: '20px 0',
      border: '2px solid #4ecdc4',
      backdropFilter: 'blur(10px)'
    },
    summaryList: {
      listStyle: 'none',
      padding: '0',
      maxWidth: '1000px',
      margin: '0 auto',
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gridTemplateRows: 'repeat(3, 1fr)',
      gap: '20px',
      height: '70vh'
    },
    summaryItem: {
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      padding: '20px',
      borderRadius: '12px',
      border: '1px solid rgba(78, 205, 196, 0.3)',
      transition: 'all 0.3s ease',
      backdropFilter: 'blur(5px)',
      boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    },
    summaryItemHover: {
      transform: 'translateX(10px)',
      borderColor: '#4ecdc4',
      boxShadow: '0 6px 20px rgba(78, 205, 196, 0.3)'
    },
    itemTitle: {
      color: '#4ecdc4',
      fontSize: '1.2em',
      marginBottom: '8px',
      fontWeight: 'bold',
      textAlign: 'center'
    },
    itemContent: {
      color: 'white',
      fontSize: '1em',
      lineHeight: '1.4',
      textAlign: 'center'
    },
    icon: {
      marginRight: '10px',
      fontSize: '1.3em'
    }
  };

  return (
    <>
      <section data-background-color="CadetBlue">
        <h1 style={styles.heading}>Récapitulatif de la séance</h1>
      </section>

      <section>
        <h2 style={{ color: 'white', marginBottom: '25px', fontSize: '1.8em' }}>
          Ce que nous avons vu
        </h2>
        <div style={styles.summaryList}>
          <div style={styles.summaryItem}>
            <div style={styles.itemTitle}>
              <span role="img" aria-label="Shield" style={styles.icon}>
                🛡️
              </span>
              Enjeux cybersécurité
            </div>
            <div style={styles.itemContent}>CIA Triad, risques, menaces</div>
          </div>
          <div style={styles.summaryItem}>
            <div style={styles.itemTitle}>
              <span role="img" aria-label="Chart" style={styles.icon}>
                📊
              </span>
              Statistiques actuelles
            </div>
            <div style={styles.itemContent}>{formatStatSummary()}</div>
          </div>
          <div style={styles.summaryItem}>
            <div style={styles.itemTitle}>
              <span role="img" aria-label="Warning" style={styles.icon}>
                ⚠️
              </span>
              Exemples concrets
            </div>
            <div style={styles.itemContent}>
              MOVEit, Okta, SolarWinds, Stuxnet...
            </div>
          </div>
          <div style={styles.summaryItem}>
            <div style={styles.itemTitle}>
              <span role="img" aria-label="Robot" style={styles.icon}>
                🤖
              </span>
              Nouvelles menaces
            </div>
            <div style={styles.itemContent}>IA générative, RaaS, APT</div>
          </div>
          <div style={styles.summaryItem}>
            <div style={styles.itemTitle}>
              <span role="img" aria-label="Computer" style={styles.icon}>
                💻
              </span>
              MI-LXC
            </div>
            <div style={styles.itemContent}>
              Plateforme pédagogique pour la pratique
            </div>
          </div>
        </div>
      </section>

      <section>
        <h2>Prochaines étapes</h2>
        <div style={styles.nextSteps}>
          <h3 style={{ color: '#4ecdc4' }}>
            <span role="img" aria-label="Target">
              🎯
            </span>{' '}
            Séance suivante : ARP Spoofing
          </h3>
          <ul>
            <li>Comprendre le protocole ARP</li>
            <li>Identifier les vulnérabilités</li>
            <li>Pratiquer avec MI-LXC</li>
            <li>Défenses et contre-mesures</li>
          </ul>
        </div>
      </section>

      <section>
        <h2>Ressources utiles</h2>
        <ul>
          <li>
            <strong>CVE Database :</strong> cve.mitre.org
          </li>
          <li>
            <strong>NIST Cybersecurity Framework</strong>
          </li>
          <li>
            <strong>OWASP Top 10</strong>
          </li>
          <li>
            <strong>ANSSI :</strong> Guide d'hygiène informatique
          </li>
        </ul>
      </section>

      <section data-background-color="CadetBlue">
        <h1 style={styles.heading}>Merci de votre attention !</h1>
        <h3 style={{ color: 'white' }}>
          Questions ?{' '}
          <span role="img" aria-label="Thinking">
            🤔
          </span>
        </h3>
      </section>
    </>
  );
}
